import {Component, Input, output,} from '@angular/core';

@Component({
    selector: 'app-numeric-up-down',
    imports: [],
    templateUrl: './numeric-up-down.component.html',
    standalone: true,
    styleUrl: './numeric-up-down.component.scss'
})
export class NumericUpDownComponent {
  @Input() value: number = 1;       // текущее число
  @Input() max: number = 100;        // максимум
  valueChange = output<number>()

  increment() {
    if (this.value < this.max) {
      this.value++;
      this.valueChange.emit(this.value);
    }
  }

  decrement() {
    if (this.value > 1) {
      this.value--;
      this.valueChange.emit(this.value);
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let val = +input.value;
    if (val > this.max) {
      val = this.max;}
    if (val < 1 || isNaN(val)) {
      val = 1;
    }
    input.value = String(this.max);
    this.value = val;
    this.valueChange.emit(this.value);
  }
}
